/**
 * @generated SignedSource<<95cd1b50c8fd10ae053fc159c0e0bf6e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PathwaySettingsAccess_ProductFragment$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ExperienceSettingsAccessSelect_ProductFragment">;
  readonly " $fragmentType": "PathwaySettingsAccess_ProductFragment";
};
export type PathwaySettingsAccess_ProductFragment$key = {
  readonly " $data"?: PathwaySettingsAccess_ProductFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"PathwaySettingsAccess_ProductFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PathwaySettingsAccess_ProductFragment",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ExperienceSettingsAccessSelect_ProductFragment"
    }
  ],
  "type": "Product",
  "abstractKey": null
};

(node as any).hash = "658d119b86ed6fd3d6eedb94c41752ea";

export default node;
